<div class="edit-section" [ngClass]="{'edit-section-delete': selectedRecord&&selectedRecord[shouldDeleteCol], 'edit-section-disabled': disableEditing}">
	<div class="operation-section">
		<div class="card-button-group">
			<button class="button-general" [disabled]="!editRecordList.length" (click)="discard()">Discard</button>
			<button class="button-general" [title]="commitDisableReason" [disabled]="checkCommitDisabled()" (click)="commit()">Commit</button>
		</div>
	</div>
	<div class="edit-top">
		<div *ngIf="selectedRecord" class="delete-rec-wrap">
			<i *ngIf="!selectedRecord[shouldDeleteCol]" class="glyphicons glyphicons-bin" (click)="onChangeDelete(true)"></i>
			<button *ngIf="selectedRecord[shouldDeleteCol]" class="btn-1" (click)="onChangeDelete(false)">Undelete</button>
		</div>
		<div class="edit-control-wrap">
			<div class="edit-control" [ngClass]="{'first-record': editRecordList.indexOf(selectedRecord)===0, 'last-record':editRecordList.indexOf(selectedRecord)===editRecordList.length-1}">
				<div class="go-prev">
					<i class="glyphicons glyphicons-chevron-left" (click)="goPrevRecord()"></i>
				</div>
				<div class="card-index">
					{{editRecordList.indexOf(selectedRecord) + 1}} / {{editRecordList.length}}
				</div>
				<div class="go-next">
					<i class="glyphicons glyphicons-chevron-right" (click)="goNextRecord()"></i>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="fsCode==='FS2' || fsCode==='FS4'">
		<select name="road-select" [(ngModel)]="selectedCenterlineId">
			<option *ngFor="let id of centerlineIds"></option>
		</select>
	</div>
	<div *ngIf="selectedRecord" class="edit-content" [ngClass]="{'delete-record': selectedRecord[shouldDeleteCol], 'edited-record': selectedRecord[this.isEditedCol]}">
		<div class="edit-row-group">
			<ng-container *ngFor="let col of columns;let idx = index;">
				<div *ngIf="col.isDisplay!==false && !col.info.hideFromEditing" class="edit-row">
					<div class="edit-column" [ngClass]="{'item-with-tooltip': col.info.tooltip}" title="{{col.info.tooltip || col.prop}}">{{col.name}}</div>
					<div class="edit-value" title="{{selectedRecord[col.prop]}}">
						<input *ngIf="!col.info.domain || (col.info.domain.type !== 'nct' && col.info.domain.type !== 'nena')"
							name="{{col.prop}}-{{idx}}"
							[disabled]="col.info.isEditDisabled || selectedRecord[shouldDeleteCol] || disableEditing"
							pattern="{{col.info.domain ? col.info.domain.pattern : ''}}"
							appValidateRange="{{col.info.domain ? col.info.domain.range : null}}"
							[(ngModel)]="selectedRecord[col.prop]" (ngModelChange)="onChange(col)">
						<select *ngIf="col.info.domain && (col.info.domain.type === 'nct' || col.info.domain.type === 'nena')"
							name="{{col.prop}}-{{idx}}"
							[disabled]="col.info.isEditDisabled || selectedRecord[shouldDeleteCol] || disableEditing"
							[ngClass]="{'invalid-select': selectedRecord[col.prop] && col.info.domain.list.indexOf(selectedRecord[col.prop]) < 0}"
							[(ngModel)]="selectedRecord[col.prop]" (ngModelChange)="onChange(col)">
							<ng-container *ngIf="selectedRecord[col.prop] && col.info.domain.list.indexOf(selectedRecord[col.prop]) < 0">
								<option disabled>{{selectedRecord[col.prop]}}</option>
							</ng-container>
							<option *ngFor="let val of col.info.domain.list" [ngValue]="val">{{val}}</option>
						</select>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>